import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { CheckboxAngularModule } from 'rev-shared/ui/checkbox/CheckboxAngular.Module';
import { DataGridModule } from 'rev-shared/ui/dataGrid/DataGrid.Module';
import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { DialogAngularModule } from 'rev-shared/ui/dialog/DialogAngular.Module';
import { DialogRegistrationService } from 'rev-shared/ui/dialog/DialogRegistration.Service';
import { FormDirectivesAngularModule } from 'rev-shared/util/directives/form/FormDirectivesAngular.Module';
import { PipesAngularModule } from 'rev-shared/pipes/Pipes.AngularModule';
import { SelectAngularModule } from 'rev-shared/ui/select/SelectAngular.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { ToolbarNgxModule } from 'rev-shared/ui/toolbar/ToolbarNgx.Module';
import { VbLoadingOverlayComponent } from 'rev-shared/ui/loadingOverlay/VbLoadingOverlay.Component';

import { ImportBoxDialogComponent } from './ImportBoxDialog.Component';
import { ImportExternalMediaService } from './ImportExternalMedia.Service';
import { ImportWebexDialogComponent } from './ImportWebexDialog.Component';
import { ImportZoomDialogComponent } from './ImportZoomDialog.Component';
import { TranscriptSelectionCellRendererComponent } from './TranscriptSelectionCellRenderer.Component';

import styles from './Import.module.less';

@NgModule({
	declarations: [
		ImportBoxDialogComponent,
		ImportWebexDialogComponent,
		ImportZoomDialogComponent,
		TranscriptSelectionCellRendererComponent
	],
	imports: [
		ButtonsAngularModule,
		CheckboxAngularModule,
		CommonModule,
		DataGridModule,
		DateAngularModule,
		DialogAngularModule,
		FormDirectivesAngularModule,
		FormsModule,
		PipesAngularModule,
		SelectAngularModule,
		SpinnerAngularModule,
		ToolbarNgxModule,
		TranslateModule,
		VbLoadingOverlayComponent
	],
	providers: [
		ImportExternalMediaService
	]
})
export class VbrickImportModule {
	constructor(dialog: DialogRegistrationService) {
		dialog.register('importWebexDialog', {
			component: ImportWebexDialogComponent,
			class: styles.dialogContainer
		});
		dialog.register('importZoomDialog', {
			component: ImportZoomDialogComponent,
			class: styles.dialogContainer
		});
		dialog.register('importBoxDialog', {
			component: ImportBoxDialogComponent,
			class: styles.dialogContainer
		});
	}
}
